import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  LinearProgress,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useApi } from "../utils/api";
import { ENDPOINTS } from "../config/endpoints";

const KurumImportModal = ({ open, onClose, onSuccess }) => {
  const http = useApi();

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setResult(null);
    setError("");
  };

  const handleImport = async () => {
    if (!file) return;

    setLoading(true);
    setError("");
    setResult(null);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await http.postForm(
        ENDPOINTS.KURUM.IMPORT,
        formData
      );

      setResult(res);
      onSuccess?.();
    } catch (err) {
      setError(err.data?.detail || err.message || "Import başarısız.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Kurum Excel Import</DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Excel başlıksız olmalıdır.
          <br />
          <strong>
            0: Kampüs Adı – 1: Şirket Ünvanı – 2: Vergi No – 3: Adres
          </strong>
        </Typography>

        <Button
          component="label"
          variant="outlined"
          startIcon={<UploadFileIcon />}
          fullWidth
        >
          Excel Dosyası Seç
          <input
            type="file"
            hidden
            accept=".xlsx"
            onChange={handleFileChange}
          />
        </Button>

        {file && (
          <Typography mt={1} variant="caption">
            Seçilen dosya: {file.name}
          </Typography>
        )}

        {loading && <LinearProgress sx={{ mt: 2 }} />}

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}

        {result && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {result.created} kurum eklendi,{" "}
            {result.skipped_count} satır atlandı.
          </Alert>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Kapat</Button>
        <Button
          variant="contained"
          onClick={handleImport}
          disabled={!file || loading}
        >
          Import Et
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KurumImportModal;
